// Per-session ride state. `riding` (+ which bike) is persisted to localStorage so a page
// refresh resumes you ON that bike at your saved location — instead of dropping you off
// and parking it at the house. Each bike's parked location + grease level live on the
// server (gameState.raw.bikes). `riding` also survives MainScene↔OutsideScene transitions.
// A bike is named by its design id (bike plan 6: one of each design).

const RIDE_KEY = 'bikeRiding_v1';
const RIDE_ID_KEY = 'bikeRidingId_v1';
// Before bike plan 6 the ride flag saved the bike's KIND ('pink' / 'blue'); such a value is read as the stored
// id and ownedBikes.resolveRideId settles which bike it means once the state is in.
const LEGACY_RIDE_TYPE_KEY = 'bikeRidingType_v1';

function loadRiding() {
  try { return localStorage.getItem(RIDE_KEY) === '1'; } catch { return false; }
}
function loadRidingId() {
  try { return localStorage.getItem(RIDE_ID_KEY) || localStorage.getItem(LEGACY_RIDE_TYPE_KEY) || null; } catch { return null; }
}

export const bikeSession = {
  riding: loadRiding(),
  ridingId: loadRidingId(),  // the design id of the bike the ride flag refers to
  greaseLocal: 0,  // working grease copy (0..grease_max) of the ridden bike (smooth speed)
  dir8: 0,         // the way the ridden bike points (8-way compass, E=0 clockwise), kept across scenes
  speedShare: 0,   // how fast it goes, a share of its top speed, and the way it rolls ({dx, dy}): ridden into
  rideDir: null,   // the next scene it goes on as it was (rideMotion.carriedRide; memory only, a reload is at rest)
};

// Set + persist the riding flag (and which bike) so it survives a reload.
export function setRiding(v, id = bikeSession.ridingId) {
  bikeSession.riding = v;
  bikeSession.ridingId = id;
  try {
    localStorage.removeItem(LEGACY_RIDE_TYPE_KEY);
    if (v) {
      localStorage.setItem(RIDE_KEY, '1');
      localStorage.setItem(RIDE_ID_KEY, id);
    } else {
      localStorage.removeItem(RIDE_KEY);
      localStorage.removeItem(RIDE_ID_KEY);
    }
  } catch { /* storage unavailable — fall back to in-memory only */ }
}

export function resetBikeSession() {
  setRiding(false);
  bikeSession.ridingId = null;
  bikeSession.greaseLocal = 0;
  bikeSession.dir8 = 0;
  bikeSession.speedShare = 0;
  bikeSession.rideDir = null;
}
